import { useServices } from 'hooks';
import { useMutation } from '@tanstack/react-query';

export const useDeleteAccount = (uuid: string) => {
	const { api } = useServices();

	const { mutateAsync: doDeletionAccountAsync } = useMutation({
		mutationFn: () => {
			return api.deleteAccount(uuid);
		},
	});

	return { doDeletionAccountAsync };
};
